import React, { useState } from 'react';
import { MapPin, Phone } from 'lucide-react';
import LabelHeading from '../../common/LabelHeading';
import img from "../../../Assets/Contact/contactimg.png"
const ContactDetails = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        companyName: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = () => {
        console.log('Form submitted:', formData);
        alert('Thank you for contacting us! We will get back to you soon.');
    };

    const branches = [
        {
            title: 'Branch-2',
            location: 'Jharpara, Bhubaneswar',
            address: "#104, 3rd main, 3rd cross, Nagendra block Srinagar, Bangalore south Karnataka 560050",
            phone: null
        },
        {
            title: 'Head Office',
            location: 'Jharpara, Bhubaneswar',
            address: 'Odyssa Business Centre, Office # 412, 4th Floor, Nh-16, Sector A, Rasulgarh, Bhubaneswar, Odisha 751010',
            phone: '+91-9078470877'
        },
        {
            title: 'Branch-3',
            location: 'Jharpara, Bhubaneswar',
            address: "Jharpara, Bhubaneswar, Khordha, 751006",
            phone: null
        }
    ];

    return (
        <div className="min-h-screen bg-gray-50">


            {/* Main Content */}
            <main className="max-w-[1400px] mx-auto px-6 xl:py-20 py-14">


                {/* Available Office Branches Section */}
                <div className="text-center mb-12">
                    <LabelHeading label={'Location'} heading={'Available Office Branches'} />


                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
                        {branches.map((branch, index) => (
                            <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100} key={index} className="bg-blue-50 flex flex-col justify-center items-center rounded-lg p-6 hover:shadow-lg transition duration-300">
                                <h3 className="text-lg font-bold text-blue-900 mb-4">{branch.title}</h3>
                                <div className="space-y-3 text-left">
                                    {
                                        branch.address && (
                                            <div className={`flex items-start`}>
                                                <MapPin className="w-5 h-5 text-blue-600 mt-1 mr-2 flex-shrink-0" />
                                                <p className="text-sm text-gray-700">{branch.address}</p>
                                            </div>
                                        )
                                    }
                                    {
                                        branch.phone && (
                                            <div className={"flex items-center"}>
                                                <Phone className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" />
                                                <p className="text-sm text-gray-700">{branch.phone}</p>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Contact Form Section */}
                <div className="text-center mb-12">
                    <LabelHeading label={'Contact Us'} heading={"Let's Contact With Us"} />

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 rounded-lg shadow-md bg-gray-200 p-6">
                        {/* Contact Form */}
                        <div className="lg:col-span-2">
                            <div data-aos="fade-up" data-aos-duration="1000" className="space-y-6">
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        className="w-full px-4 py-3 bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="w-full px-4 py-3 bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                    <input
                                        type="tel"
                                        name="phone"
                                        placeholder="Phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        className="w-full px-4 py-3 bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                    <input
                                        type="text"
                                        name="companyName"
                                        placeholder="Your Company Name"
                                        value={formData.companyName}
                                        onChange={handleChange}
                                        className="w-full px-4 py-3 bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                </div>
                                <textarea
                                    name="message"
                                    placeholder="Write Your Message Here"
                                    value={formData.message}
                                    onChange={handleChange}
                                    rows="6"
                                    className="w-full px-4 py-3 bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                                ></textarea>
                                <div className="text-left">
                                    <button
                                        onClick={handleSubmit}
                                        className="bg-blue-900 hover:bg-blue-800 text-white font-semibold px-8 py-3 rounded-lg transition duration-200"
                                    >
                                        Submit Now
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Contact Image */}
                        <div className="lg:col-span-1">
                            <div data-aos="fade-up" data-aos-duration="1000" className="relative">
                                <img
                                    src={img}
                                    alt="Contact us"
                                    className="w-full h-full object-cover rounded-lg shadow-lg"
                                />

                            </div>
                        </div>
                    </div>
                </div>

                {/* Map Section */}
                <div className="mt-12">
                    <div data-aos="fade-up" data-aos-duration="1000" className="w-full h-96 bg-gray-200 rounded-lg overflow-hidden">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3742.0068093540517!2d85.85943667501066!3d20.29998528117321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a190bd65aa2ad1d%3A0xe69acb08745a4b10!2sOdyssa%20Business%20Centre!5e0!3m2!1sen!2sin!4v1764757590866!5m2!1sen!2sin"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Office Location Map"
                        ></iframe>
                    </div>
                </div>
            </main>

        </div>
    );
};

export default ContactDetails;